import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useEffect } from "react";
//#region src/modules/Records/shared/UserClientViewingRecord.tsx
function UserClientViewingRecord({ recordId }) {
	const { rpcService } = useRPCContext();
	useEffect(() => {
		const t = setTimeout(() => rpcService.UserClient.ViewRecord.v1.call({ recordId }), 3e3);
		return () => {
			clearTimeout(t);
		};
	}, [recordId]);
	return null;
}
//#endregion
export { UserClientViewingRecord };

//# sourceMappingURL=UserClientViewingRecord.js.map